import { useLazyQuery } from '@apollo/client';
import { logException } from '../App/logging';
import { USER_LOCALE_QUERY } from './getDbUserLocale';
import { getUserLocale } from './getUserLocale';
import { useUpdateDbUserLocale } from './updateDbUserLocale';
import { userLocaleQuery } from './__generated__/userLocaleQuery';

export const useUpdateDbUserLocaleIfNeeded = () => {
  const userLocale = getUserLocale();
  const { updateDbUserLocale } = useUpdateDbUserLocale();

  const [updateDbUserLocaleIfNeeded, { data, loading }] =
    useLazyQuery<userLocaleQuery>(USER_LOCALE_QUERY, {
      fetchPolicy: 'network-only',
      onCompleted: async returnedData => {
        try {
          const dbUserLocale = returnedData?.user?.userLocale;

          const dbUserLocaleNeedsUpdating =
            dbUserLocale === null || dbUserLocale?.value !== userLocale;

          if (dbUserLocaleNeedsUpdating) {
            const originalLocale = navigator.language;
            await updateDbUserLocale(userLocale, originalLocale);
          }
        } catch (error) {
          logException(error);
        }
      },
      onError: error => {
        logException(error);
      },
    });

  const hasBeenUpdated = data !== undefined;

  return { updateDbUserLocaleIfNeeded, loading, hasBeenUpdated };
};
